export default function(a, b) {
  if (a.length !== b.length) {
    return false
  }

  return a.every( e => b.includes(e) ) && b.every( e => a.includes(e) )
}